import React from 'react'
import { formatUnitsForReport, mapUnits } from '../../../helpers/units';

export const columnsItemOutbound = (props,loadItemOutboundDetails,selectFilter,selectedRow,dynamicSort,selectedBranch) => {
    return [

      {
        dataField: "item_id",
        hidden: true,
      },
      {
        dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
        text: props.t("S.N"),
        headerStyle: (colum, colIndex) => {
          return { width: "5%" };
        },
      },
  
      {
        text: props.t("Item"),
        dataField: "name",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "22%" };
        },
        formatter: (cell, row, rowIndex) => {
          const isDisabled = selectedBranch.type !== "Branch";
          return (
            <span
            className={`text-info mr-2 ${isDisabled ? 'text-muted' : ''}`}
            title="View Details"
            style={{ 
              cursor: isDisabled ? "not-allowed" : "pointer",
              pointerEvents: isDisabled ? "none" : "auto"
            }} 
            disabled={isDisabled}
            onClick={() => {
              if (isDisabled) return;
                loadItemOutboundDetails(row.item_id);
              }}
            >
            {row.name} <span hidden={!row.is_free} className="text-danger font-weight-bold" style={{fontSize:"20px"}}>*</span>
            </span>
          );
        },
      },
      // {
      //   text: props.t("Category"),
      //   dataField: "category",
      //   sort: true,
      //   headerStyle: (colum, colIndex) => {
      //     return { width: "10%" };
      //   },
      //   filter: selectFilter({
      //     options: () => {
      //       const unique = [
      //         ...new Map(
      //           [
      //             ...new Set(
      //               selectedRow?.map(({ category: value }) => ({
      //                 value: value,
      //                 label: value,
      //               }))
      //             ),
      //           ].map((item) => [item["value"], item])
      //         ).values(),
      //       ];
  
      //       unique.sort(dynamicSort("label"));
      //       return unique;
      //     },
      //   }),
      // },
      {
        dataField: "name",
        text: props.t("Formula"),
        sort: true,
        formatter: (cell,row)=>{
          return mapUnits(row?.unit_levels)
        },
        headerStyle: (colum, colIndex) => {
          return { width: "14%" };
        },
      },
  //  {
  //         dataField: "is_free",
  //         text: props.t("Free ?"),
  //         sort: true,
  //         headerStyle: (colum, colIndex) => {
  //           return { width: "10%" };
  //         },
  //         formatter: cell => (
  //           cell ? 'Yes' : 'No'
  //         ),
  //         filter: selectFilter({
  //           options: [
  //             { value: true, label: "Yes" },  
  //             { value: false, label: "No" }   
  //           ],
  //           placeholder: "All"
  //         })
  //       },
      {
        dataField: "unit",
        text: props.t("Quantity"),
        formatter: (cell, row) => {
          return formatUnitsForReport(row.quantity)
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "13%" };
        },
      },
      {
        dataField: "unit_for_po",
        text: props.t("Purchasing Unit"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
      // {
      //   dataField: "cost_price",
      //   text: props.t("Price (QR)"),
      //   formatter: (cell,row)=>{
      //     // return row?.cost_price + "/" + row?.unit_for_po
      //     return row?.cost_price
      //    },
      //   sort: true,
      //   headerStyle: (colum, colIndex) => {
      //     return { width: "10%" };
      //   },
      // },
  
      {
        dataField: "receiving_cost",
        text: props.t("Total Cost (QR)"),
        formatter: (cell, row, rowIndex) => {
          return Number(row.receiving_cost.toFixed(2));
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "6%" };
        },
      }
    ]
}

export const columnsItemOutboundDetails = (props,selectFilter,itemOutboundDetails,dynamicSort) => {
  return [

    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_details.seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "item_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      }
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "item_details.category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               itemOutboundDetails?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "branch_to.name",
      text: props.t("Branch To"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" }
      },
    },
    {
      dataField: "item_details.name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.item_details?.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
 {
        dataField: "item_details.is_free",
        text: props.t("Free ?"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
        formatter: cell => (
          cell ? 'Yes' : 'No'
        ),
        filter: selectFilter({
          options: [
            { value: true, label: "Yes" },  
            { value: false, label: "No" }   
          ],
          placeholder: "All"
        })
      },
    {
      dataField: "item_details.name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.item_details.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "item_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "item_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.item_details.cost_price + "/" + row?.item_details.unit_for_po
      //  },
       formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (row?.item_details.free_cost_price);
        } else {
          return row?.item_details.cost_price
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "item_details.receiving_cost",
      text: props.t("Total Cost (QR)"),
      formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.item_details.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.item_details.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    }
  ]
}
export const columnsItemInbound = (props,loadItemInboundDetails,selectFilter,selectedRow,dynamicSort,selectedBranch) => {
  return [

    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      },
      formatter: (cell, row, rowIndex) => {
        const isDisabled = selectedBranch.type !== "Branch";

        return (
          <span
          className={`text-info mr-2 ${isDisabled ? 'text-muted' : ''}`}
            title="View Details"
            style={{ 
              cursor: isDisabled ? "not-allowed" : "pointer",
              pointerEvents: isDisabled ? "none" : "auto"
            }}
            disabled={isDisabled}
            onClick={() => {
              if (isDisabled) return;
              loadItemInboundDetails(row.item_id);
            }}
          >
            {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            </span>
        );
      },
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
   
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
 {
        dataField: "is_free",
        text: props.t("Free ?"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
        formatter: cell => (
          cell ? 'Yes' : 'No'
        ),
        filter: selectFilter({
          options: [
            { value: true, label: "Yes" },  
            { value: false, label: "No" }   
          ],
          placeholder: "All"
        })
      },
    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell,row)=>{
    //     // return row?.cost_price + "/" + row?.unit_for_po
    //     return row?.cost_price
    //    },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    }
  ]
}
export const columnsItemInboundDetails = (props,selectFilter,itemInboundDetails,dynamicSort) => {
  return [

    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_details.seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "item_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      }
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "item_details.category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               itemInboundDetails?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "branch_from.name",
      text: props.t("Branch From"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "item_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.item_details.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
 {
        dataField: "item_details.is_free",
        text: props.t("Free ?"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
        formatter: cell => (
          cell ? 'Yes' : 'No'
        ),
        filter: selectFilter({
          options: [
            { value: true, label: "Yes" },  
            { value: false, label: "No" }   
          ],
          placeholder: "All"
        })
      },
    {
      dataField: "item_details.name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.item_details.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "item_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "item_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.item_details.cost_price + "/" + row?.item_details.unit_for_po
      //  },
       formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (row?.item_details.free_cost_price);
        } else {
          return row?.item_details.cost_price
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      dataField: "item_details.receiving_cost",
      text: props.t("Total Cost (QR)"),
      formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.item_details?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.item_details.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    }
  ]
}
export const columnsProductOutbound = (props,loadProductOutboundDetails,selectFilter,selectedRow,dynamicSort,selectedBranch) => {
  return [

    {
      dataField: "product_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      formatter: (cell, row, rowIndex) => {
        const isDisabled = selectedBranch.type !== "Branch";
        return (
          <span
          className={`text-info mr-2 ${isDisabled ? 'text-muted' : ''}`}
            title="View Details"
            style={{ 
              cursor: isDisabled ? "not-allowed" : "pointer",
              pointerEvents: isDisabled ? "none" : "auto"
            }}
            disabled={isDisabled}
            onClick={() => {
              if (isDisabled) return;
              loadProductOutboundDetails(row.product_id);
            }}
          >
            {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            </span>
        );
      },
    },
    // {
    //   text: props.t("Section"),
    //   dataField: "section",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ section: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
   
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_cost_price",
      text: props.t("Costing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell,row)=>{
    //     // return row?.cost_price + "/" + row?.unit_for_cost_price
    //     return row?.cost_price 
    //    },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    }
  ]
}

export const columnsProductOutboundDetails = (props,selectFilter,productInboundDetails,dynamicSort) => {
  return [

    {
      dataField: "product_id",
      hidden: true,
    },
    {
      dataField: "product_details.seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Product"),
      dataField: "product_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      }
    },
    // {
    //   text: props.t("Section"),
    //   dataField: "product_details.section",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
      // filter: selectFilter({
      //   options: () => {
      //     const unique = [
      //       ...new Map(
      //         [
      //           ...new Set(
      //             productInboundDetails?.map(({ section: value }) => ({
      //               value: value,
      //               label: value,
      //             }))
      //           ),
      //         ].map((item) => [item["value"], item])
      //       ).values(),
      //     ];

      //     unique.sort(dynamicSort("label"));
      //     return unique;
      //   },
      // }),
    // },
    {
      dataField: "branch_to.name",
      text: props.t("Branch To"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "product_details.name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.product_details.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "product_details.name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.product_details.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "product_details.unit_for_cost_price",
      text: props.t("Costing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "product_details.cost_price",
      text: props.t("Price (QR)"),
      formatter: (cell,row)=>{
        return row?.product_details.cost_price
       },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "product_details.receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    }
  ]
}

export const columnsProductInbound = (props,loadProductInboundDetails,selectFilter,selectedRow,dynamicSort,selectedBranch) => {
  return [

    {
      dataField: "product_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Product"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      },
      formatter: (cell, row, rowIndex) => {
        const isDisabled = selectedBranch.type !== "Branch";
        return (
          <span
          className={`text-info mr-2 ${isDisabled ? 'text-muted' : ''}`}
            title="View Details"
            style={{ 
              cursor: isDisabled ? "not-allowed" : "pointer",
              pointerEvents: isDisabled ? "none" : "auto"
            }}
            disabled={isDisabled}
            onClick={() => {
              if (isDisabled) return;
              loadProductInboundDetails(row.product_id);
            }}
          >
            {row.name} <span hidden={!row.is_free} className="text-danger font-weight-bold">*</span>
            </span>
        );
      },
    },
    // {
    //   text: props.t("Section"),
    //   dataField: "section",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ section: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_cost_price",
      text: props.t("Costing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell,row)=>{
    //     // return row?.cost_price + "/" + row?.unit_for_cost_price
    //     return row?.cost_price 
    //    },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    }
  ]
}

export const columnsProductInboundDetails = (props,selectFilter,productOutboundDetails,dynamicSort) => {
  return [

    {
      dataField: "product_id",
      hidden: true,
    },
    {
      dataField: "product_details.seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Product"),
      dataField: "product_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      }
    },
    // {
    //   text: props.t("Section"),
    //   dataField: "product_details.section",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               productOutboundDetails?.map(({ section: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "branch_from.name",
      text: props.t("Branch From"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "product_details.name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row?.product_details.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "product_details.name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.product_details.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "product_details.unit_for_cost_price",
      text: props.t("Costing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "product_details.cost_price",
      text: props.t("Price (QR)"),
      formatter: (cell,row)=>{
        // return row?.product_details.cost_price + "/" + row?.product_details.unit_for_cost_price
        return row?.product_details.cost_price
       },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "product_details.receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    }
  ]
}